var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 95.983,
    height: 96.111,
    viewBox: "0 0 95.983 96.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.892,
    y1: 0.107,
    x2: 0.152,
    y2: 0.893,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1b515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#fffb9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1900b"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_5",
    x: 0,
    y: 0,
    width: 95.983,
    height: 96.111,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.91
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4156",
    "data-name": "Group 4156",
    transform: "translate(38 23)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -38, -23)",
    filter: "url(#Union_5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_5-2",
    "data-name": "Union 5",
    d: "M19.983,9.991v.128A9.991,9.991,0,0,1,0,10.119V9.991a9.991,9.991,0,0,1,19.983,0Z",
    transform: "translate(38 23)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104",
    transform: "translate(2.871 2.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2989",
    "data-name": "Path 2989",
    d: "M378.465,1101.344a.863.863,0,0,1-.391-.166,2.333,2.333,0,0,0,.123,2.434s.059-1.026.72-1.17A5.449,5.449,0,0,1,378.465,1101.344Z",
    transform: "translate(-376.505 -1092.925)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2990",
    "data-name": "Path 2990",
    d: "M496.658,1252.022a5.392,5.392,0,0,1-1.527-1.036,6.7,6.7,0,0,1-1.28-1.732l-.084-.163c-.137.428-.39,1.8,1.281,3.308,0,0-.157-.79.494-.943a3.48,3.48,0,0,0,2.666,2.765A4.089,4.089,0,0,1,496.658,1252.022Z",
    transform: "translate(-491.294 -1239.451)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2991",
    "data-name": "Path 2991",
    d: "M681.282,1233.1c.134.146.268.281.4.407.044.042.088.083.131.124a1.842,1.842,0,0,1,.475-1.529A1.6,1.6,0,0,0,681.282,1233.1Z",
    transform: "translate(-677.15 -1222.622)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2992",
    "data-name": "Path 2992",
    d: "M515.469,345.749a.813.813,0,0,1-.376.1.759.759,0,0,1-.148-.015.662.662,0,0,1-.522-.424l-.019-.061.013-.063a13.142,13.142,0,0,0,.2-3.605l-.008-.064a1.119,1.119,0,0,1-1.878.521s1.086.165,1.218-.806a1.108,1.108,0,0,1-1.218-.609,3.179,3.179,0,0,0,.986-.56,8.648,8.648,0,0,0-1.493-.406,4.471,4.471,0,0,1-1.122.2.681.681,0,0,1-.223-.359q-.29-.016-.585-.018v0l-.218,0h-.012q-.013.039-.023.08h0a1.236,1.236,0,0,1-.176-.075l0,0q-.043-.023-.082-.049h0a1.008,1.008,0,0,1-.21-.182,1.137,1.137,0,0,1-.253-.547,1.3,1.3,0,0,1-.021-.232c0-.03,0-.046,0-.046a.715.715,0,0,0-.059.048l-.006.006-.013.012-.043.041-.018.019-.005.005-.01.011-.008.008-.007.008-.014.016-.009.011-.009.011-.011.014-.012.015-.012.016-.025.033-.009.013-.008.011-.016.023-.008.012-.012.019-.014.023,0,.008,0,.008-.009.016-.013.023c-.011.021-.022.043-.033.066l-.01.023-.018.044,0,.011-.014.038-.007.02-.006.019-.007.021,0,.008-.007.024c0,.017-.009.034-.013.051l0,.013,0,.01,0,.022,0,.022c0,.015-.006.03-.008.046v0l0,.02v.01l0,.019s0,.01,0,.015v.016s0,.01,0,.015v0l0,.016c0,.01,0,.02,0,.03v0c0,.006,0,.012,0,.018a.017.017,0,0,0,0,0c0,.006,0,.011,0,.017s0,.008,0,.012a0,0,0,0,0,0,0s0,.009,0,.013,0,.013,0,.02a.008.008,0,0,0,0,0,0,0,0,0,0,0,0h0s0,0,0,0,0,0,0,0,0,.018,0,.028,0,.013,0,.02,0,.014,0,.021,0,.008,0,.012,0,.006,0,.009,0,.013,0,.02v.008c0,.007,0,.015,0,.023v.014c0,.012,0,.025,0,.038l0,.018c0,.014,0,.029.006.043l0,.014,0,.027,0,.027.006.03.006.031.007.031,0,.019,0,.016.007.028v0l-.017-.03,0-.007,0,0,0,0-.008-.013,0,0-.014-.023-.009-.015c-.026-.042-.06-.094-.1-.152l-.014-.019-.015-.019c-.036-.048-.078-.1-.126-.152l-.014-.016-.02-.022-.012-.013-.012-.013-.035-.036-.01-.01-.033-.033-.014-.013-.057-.053-.034-.03-.018-.015-.019-.016-.008-.007-.019-.016-.048-.038-.027-.021-.026-.019-.01-.007-.055-.038-.006,0-.006,0-.026-.017-.03-.019-.055-.033-.01-.006-.022-.013-.03-.017-.01-.005-.01-.005-.02-.01-.017-.008-.025-.012-.013-.006-.031-.014-.024-.011-.007,0-.019-.008-.031-.013-.018-.007-.015-.006h0v0l0,0v0c0,.009.013.026.024.049l0,.011,0,.006,0,.006.008.018v0l0,.007.006.014,0,.011.008.021,0,.011,0,0h0l0,.011,0,0,0,.011,0,.009.006.019.006.02,0,.011.005.018,0,.016,0,.012,0,.007,0,.015v0l0,.014,0,.012,0,.012.006.028.006.029c0,.016.006.033.009.051l0,.028h0v.009a.04.04,0,0,1,0,.006c0,.009,0,.018,0,.028l0,.023c0,.006,0,.013,0,.019s0,.026,0,.039,0,.013,0,.02,0,.013,0,.02,0,.023,0,.035,0,.014,0,.021,0,.021,0,.031,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,.007,0,.011,0,.016,0,.006,0,.008,0,.01,0,.015,0,.024,0,.036,0,.015,0,.023,0,.015,0,.023,0,.031,0,.047,0,.016,0,.024,0,.032-.006.048l0,.024,0,.024,0,.025,0,.025-.005.025-.005.024,0,.009,0,.017,0,.017-.006.022-.005.02-.012.04,0,.012-.008.024h0l-.017.049-.008.022-.008.021-.007.018-.006.014-.014.033-.021.046-.026.054a1.5,1.5,0,0,1-.2-.111l-.007,0a2.494,2.494,0,0,1-.251-.182,2.805,2.805,0,0,1-.3-.284,7.373,7.373,0,0,0-.76.276,1.955,1.955,0,0,0,1.319.9.893.893,0,0,0-.464,1.1c-.955-.016-1.375-1.28-1.375-1.28-.034.2-.06.374-.08.527a5.058,5.058,0,0,0-.069.921,14.688,14.688,0,0,0,.26,2.836l.013.063-.019.061a.468.468,0,0,1-.027.066,6.221,6.221,0,0,0,1.339,2.336,2.9,2.9,0,0,1-.034-2.506s-.338-.063-.757.445c0,0,.179-2.512,2.315-1.762,0,0-.192-.757-.752-.757,0,0,1.942-.955,2.222,1.481a.963.963,0,0,0-.774-.313,1.532,1.532,0,0,1,.642,1.6,1.647,1.647,0,0,1,.872.54,1.328,1.328,0,0,0-1.267.448s.56-.214,1.168.51a.735.735,0,0,0-1.02.379c.012-.006.861-.432,1.212.675,0,0-.735.692-1.229-.033a1,1,0,0,0,.329,1.317s-.033.115-.527-.181c.008.013.565.9,1.3.773s1.2-.905.938-1.415c0,0,.395,0,.444.642a2.885,2.885,0,0,0,0-2.518,1.575,1.575,0,0,1,.626.823,2.084,2.084,0,0,0-.51-1.794,1.056,1.056,0,0,1,.1-1.843c.372-.218,1.119-.346.955-.987a.991.991,0,0,1,.271.806.488.488,0,0,0,.256-.3,1.776,1.776,0,0,1-1.058,1.951,2.372,2.372,0,0,1,.5,2.476,1.915,1.915,0,0,0,.444-1.926,2.57,2.57,0,0,1-.477,3.193,2.481,2.481,0,0,0,1.267-2.748s.609.444.444,1.942a3.23,3.23,0,0,0,.629-2.994Z",
    transform: "translate(-502.922 -337.417)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2993",
    "data-name": "Path 2993",
    d: "M1366.294,222.659l.1.04a1.217,1.217,0,0,0,0-.229,1.337,1.337,0,0,1,.3.362h0a5.423,5.423,0,0,1,.975.586,2.673,2.673,0,0,0-1.475-2.519,2.481,2.481,0,0,1-.58,1.532C1365.842,222.495,1366.07,222.57,1366.294,222.659Z",
    transform: "translate(-1355.068 -220.898)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2994",
    "data-name": "Path 2994",
    d: "M380.856,222.47q.057.181.119.342.174-.08.358-.153.159-.062.32-.117a4.4,4.4,0,0,1-.3-1.644,4.3,4.3,0,0,0-1.726,2.8,4.848,4.848,0,0,1,.819-.606A3.074,3.074,0,0,1,380.856,222.47Z",
    transform: "translate(-378.32 -220.898)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2995",
    "data-name": "Path 2995",
    d: "M1491.824,571.567l-.006.018.062-.044a1.071,1.071,0,0,1,.554-.19.643.643,0,0,1,.075,0c.013-.048.025-.1.037-.149a4.464,4.464,0,0,0-.56-.417A3.64,3.64,0,0,1,1491.824,571.567Z",
    transform: "translate(-1480.087 -567.51)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2996",
    "data-name": "Path 2996",
    d: "M738.367,946.942a.678.678,0,0,0,.64.583.563.563,0,0,0,.4-.171c.143.037.245.34.245.34a1.3,1.3,0,0,0-1.525-1.317l.269.159S738.29,946.591,738.367,946.942Zm.209-.368a.948.948,0,0,1,.254.058.249.249,0,1,0,.368.283.907.907,0,0,1,.152.323.535.535,0,0,1-.651-.055A.513.513,0,0,1,738.575,946.574Z",
    transform: "translate(-733.466 -939.566)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2997",
    "data-name": "Path 2997",
    d: "M1200.295,941.417s.1-.3.245-.34a.615.615,0,0,0,.413.163.662.662,0,0,0,.632-.574c.077-.351-.033-.406-.033-.406l.269-.159S1199.991,939.87,1200.295,941.417Zm.958-.51a.536.536,0,0,1-.651.055.9.9,0,0,1,.132-.3.249.249,0,1,0,.381-.308.938.938,0,0,1,.26-.06A.512.512,0,0,1,1201.252,940.906Z",
    transform: "translate(-1191.263 -933.346)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2998",
    "data-name": "Path 2998",
    d: "M384.941,655.557a.9.9,0,0,0-.413-.151.419.419,0,0,0-.161.022.766.766,0,0,0-.318.222.592.592,0,0,0-.061.083,17.514,17.514,0,0,0,0,2.051,6.379,6.379,0,0,0,.21,1.355,2.4,2.4,0,0,0,.084.236l.024.02a.622.622,0,0,0,.466.124h0l.016.056c.016.053.033.109.052.167a6.684,6.684,0,0,0,3.18,3.98,5.119,5.119,0,0,0,.665.264.08.08,0,0,0,.093-.034l.279-.449a.092.092,0,0,0-.023-.122l-.377-.28a.092.092,0,0,0-.14.041l-.119.312s-.032.083-.331-.133c-.12-.086-.321-.274-.469-.394-.093-.075-.19-.157-.29-.244a7.772,7.772,0,0,1-2.2-3.055c-.016-.043-.032-.087-.047-.132s-.021-.062-.031-.093h0a.376.376,0,0,0,.115-.158,14.4,14.4,0,0,1-.256-3.139C384.9,655.921,384.918,655.736,384.941,655.557Z",
    transform: "translate(-382.612 -651.332)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2999",
    "data-name": "Path 2999",
    d: "M331.084,708.7a7.047,7.047,0,0,1-.166-1.239h0c-.065-1.038-.015-2.133-.015-2.133a5.675,5.675,0,0,0-.353.617,19.061,19.061,0,0,0,0,2.387.587.587,0,0,0,.317.346A.4.4,0,0,0,331.084,708.7Z",
    transform: "translate(-329.663 -700.783)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3000",
    "data-name": "Path 3000",
    d: "M1489.807,655.428a.4.4,0,0,0-.129-.023.87.87,0,0,0-.446.152,13.3,13.3,0,0,1-.206,3.689.447.447,0,0,0,.357.269.607.607,0,0,0,.443-.091.515.515,0,0,0,.066-.049,2.526,2.526,0,0,0,.11-.327,6.328,6.328,0,0,0,.173-1.113h0c.013-.157.022-.315.028-.47h0c.016-.381.015-.746.009-1.042,0-.053,0-.1,0-.151-.009-.327-.024-.539-.024-.539a.689.689,0,0,0-.127-.151h0A.748.748,0,0,0,1489.807,655.428Z",
    transform: "translate(-1477.322 -651.332)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3001",
    "data-name": "Path 3001",
    d: "M1608.348,705.324s.008.19.014.486c0,.022,0,.045,0,.069a19.07,19.07,0,0,1-.061,1.976h0s0,0,0,0,0,.019,0,.029a5.7,5.7,0,0,1-.129.8l0,.01.01,0a.4.4,0,0,0,.188-.018l.01,0a.581.581,0,0,0,.323-.349,19.2,19.2,0,0,0,0-2.387A5.714,5.714,0,0,0,1608.348,705.324Z",
    transform: "translate(-1595.346 -700.783)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3002",
    "data-name": "Path 3002",
    d: "M241.218,394.3a.157.157,0,0,0-.06-.022,2.809,2.809,0,0,1,.7-1.347,3.944,3.944,0,0,1,.484-.451,5.547,5.547,0,0,1,1.213-.715,7.436,7.436,0,0,1,.731-.275,8.851,8.851,0,0,1,.87-.229,1.37,1.37,0,0,0-.134-.446l-.068-.12a8.414,8.414,0,0,0-.994.263,6.741,6.741,0,0,0-.686.27,5.406,5.406,0,0,0-.78.438h0a4.36,4.36,0,0,0-.683.572,3.911,3.911,0,0,0-1.044,2.079c-.09.026-.1.068-.1.068a2.42,2.42,0,0,0,.386,2.272c.184.078.17-.055.17-.055A21.41,21.41,0,0,1,241.218,394.3Z",
    transform: "translate(-240.532 -389.099)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3003",
    "data-name": "Path 3003",
    d: "M776.536,370.912c-.246.017-.516.043-.8.083a2.623,2.623,0,0,1,.618.454A1.648,1.648,0,0,1,776.536,370.912Z",
    transform: "translate(-770.719 -369.506)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3004",
    "data-name": "Path 3004",
    d: "M954.888,371.872s-.014-.042-.1-.068a3.91,3.91,0,0,0-1.379-2.389l-.032-.026a4.929,4.929,0,0,0-.809-.532c-.164-.087-.333-.166-.5-.237a7.35,7.35,0,0,0-.914-.31,10.571,10.571,0,0,0-2.335-.335v0l-.013,0h0c-.462-.016-.792,0-.9.007-.073,0-.246-.013-.493-.014a.842.842,0,0,0,.37.546h.258c.227,0,.451,0,.671.016a10.81,10.81,0,0,1,1.775.235,8.379,8.379,0,0,1,1.276.386,6.338,6.338,0,0,1,.934.458,4.861,4.861,0,0,1,.6.425q.09.075.174.153a2.929,2.929,0,0,1,.927,1.577.158.158,0,0,0-.06.022,21.433,21.433,0,0,1,0,2.3s-.014.133.17.055A2.419,2.419,0,0,0,954.888,371.872Z",
    transform: "translate(-940.778 -366.589)",
    fill: "#1d1d1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatYellow);
export default __webpack_public_path__ + "static/media/chat-yellow.a3cf89f167edade6b0b8f7b281595bf1.svg";
export { ForwardRef as ReactComponent };